import React, { useState } from 'react';
import { Button, Typography, Paper, Box, LinearProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DateInputLeftLabel } from 'src/shared/components/date_picker_component';
import Swal from 'sweetalert2';
import { getActivitiesToassociatedDynCards } from './api';
import { Activity } from './interfaces';

interface Step1DateSelectionProps {
  onNext: (activities: Activity[], startDate: string, endDate: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const Step1DateSelection: React.FC<Step1DateSelectionProps> = ({
  onNext,
  loading,
  setLoading,
}) => {
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const handleContinue = async () => {
    const messageWithErrors: string[] = [];

    if (!startDate || startDate === null) {
      messageWithErrors.push('Se requiere agregar una fecha Inicio');
    }

    if (!endDate || endDate === null) {
      messageWithErrors.push('Se requiere agregar una fecha Fin');
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      messageWithErrors.push('La fecha de inicio no puede ser posterior a la fecha de fin');
    }

    if (messageWithErrors.length > 0) {
      Swal.fire({
        title: 'Error',
        html: `<p>No se puede continuar debido a los siguientes errores:</p><ul>${messageWithErrors.map(error => `<li>${error}</li>`).join('')}</ul>`,
        icon: 'error',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    try {
      setLoading(true);
      const activities = await getActivitiesToassociatedDynCards(startDate!, endDate!);
      
      if (!activities || activities.length === 0) {
        Swal.fire({
          title: 'Sin resultados',
          text: 'No se encontraron actividades para el rango de fechas seleccionado',
          icon: 'info',
          confirmButtonText: 'Aceptar',
        });
        setLoading(false);
        return;
      }

      onNext(activities, startDate!, endDate!);
    } catch (error: any) {
      Swal.fire({
        title: 'Error',
        text: error.message || 'Error al obtener las actividades',
        icon: 'error',
        confirmButtonText: 'Aceptar',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <>
          <Box className="modal_analyst_loading_background" />
          <Box className="modal__analyst_task_loading">
            <LinearProgress />
            Consultando....
          </Box>
        </>
      )}
      <Grid container className="dyn-cards-wizard-container" spacing={2} justifyContent="center">
        <Paper className="dyn-cards-wizard-paper" elevation={2}>
          <Typography className="dyn-cards-wizard-title" sx={{ fontSize: 16, fontWeight: 600 }}>
            PASO 1: SELECCIONAR RANGO DE FECHA
          </Typography>
          <Grid className="dyn-cards-wizard-fields" sx={{ marginTop: 10 }}>
            <DateInputLeftLabel
              label="Fecha Inicio"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onClear={() => setStartDate('')}
            />
            <DateInputLeftLabel
              label="Fecha Fin"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onClear={() => setEndDate('')}
            />
          </Grid>
          <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleContinue}
              disabled={loading || !startDate || !endDate}
            >
              Continuar
            </Button>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

